var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.2227C21.6569 28.2227 23 29.5658 23 31.2227C22.9997 32.8793 21.6567 34.2227 20 34.2227C18.3433 34.2227 17.0003 32.8793 17 31.2227C17 29.5658 18.3431 28.2227 20 28.2227Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.72168C24.4183 6.72168 28 10.3044 28 14.7227V20.6016C28 22.4357 29.2474 24.035 31.0264 24.4814L32 24.7256V26.7227H8V24.7256L8.97363 24.4814C10.7526 24.035 12 22.4357 12 20.6016V14.7217C12.0003 10.3036 15.5819 6.72168 20 6.72168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBell);
export default __webpack_public_path__ + "static/media/notifications-bell.8bc8d6b48baf4dc2e58cbc6c5bfc00e4.svg";
export { ForwardRef as ReactComponent };